import { useState } from "react";
import { useLocalStorage } from "./useLocalStorage";



const getQueryParam = (key: string): string => {
	const params = new URLSearchParams(window.location.search);
	return params.get(key) || '';
};

const setQueryParam = (key: string, value: string): void => {
	const params = new URLSearchParams(window.location.search);
	if (value) {
		params.set(key, value);
	} else {
		params.delete(key);
	}

	// update the URL without reloading the page
	window.history.replaceState({}, '', `?${params.toString()}`);
};

export function useQueryState(paramName: string, options?: {
	persist: true, // save value to session state
}): [string, (newValue: string) => void] {

	const key = "query_state_" + paramName;
	const [lsValue, setLS] = useLocalStorage(key, "");

	let initialValue = getQueryParam(paramName);
	if (!initialValue && options && options.persist) {
		// see have local storage value for it
		if (lsValue) initialValue = lsValue;
	}

	const [state, setState] = useState(initialValue);

	const updateState = (newValue: string) => {
		setState(newValue);
		setQueryParam(paramName, newValue);

		if (options && options.persist) {
			setLS(newValue);
		}
	};

	return [
		state, updateState as (newValue: string) => void,
	];
}